export const EventPublicType = {
  SHARED: 0, ACCESS_LINK_ONLY: 1, PRIVATE: 2
}
